




















































































































































































































































import {Component, Mixins, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {OrbitLeaderboardEntry} from '@/model/resource/OrbitLeaderboardEntry'

@Component
export default class OrbitLeaderboardScrollableTable extends Mixins(
  MixinScreenSize
) {
  @Prop({type: Array, required: true}) entries!: OrbitLeaderboardEntry[]
  @Prop({type: Number, required: true}) currentPage!: number
  @Prop({type: Number, required: true}) pageSize!: number

  getRank(index: number) {
    return (this.currentPage - 1) * this.pageSize + index + 1
  }

  copyToClipboard(address: string | null) {
    if (!address) return
    this.$utils.copyToClipboard(address)
    this.$toast.info('system.info.copiedToClipboard')
  }

  formattedAddress(address: string | null) {
    if (!address) return ''

    if (!this.isLessThanTablet) return address

    return `${address.slice(0, 5)}...${address.slice(-5)}`
  }

  formatGasRewards(amount: number) {
    if (!amount) return '0 GAS'

    const formatted = Number.isInteger(amount)
      ? String(amount)
      : amount.toFixed(3).replace(/\.?0+$/, '')

    return `${formatted} GAS`
  }
}
